export class GoogleRemarketingTracker
{
    constructor() {
        window.google_tag_params = window.google_tag_params || {};
        this.google_tag_params = window.google_tag_params;
        this.pageType = 'other';
        this.productId = '';
        this.totalValue = 0;
    }

    set pageType(type) {
        this.google_tag_params.ecomm_pagetype = type;
    }

    set productId(id) {
        this.google_tag_params.ecomm_prodid = id;
    }

    set totalValue(price) {
        this.google_tag_params.ecomm_totalvalue = price;
    }

    indexPageView() {
        this.pageType = 'home';
        this.productId = '';
        this.totalValue = 0;
    }

    categoryPageView(products) {
        let ids = [], prices = [];
        products.forEach(product => {
            ids.push(product.id);
            prices.push(product.price);
        });

        this.pageType = 'category';
        this.productId = ids;
        this.totalValue = prices;
    }

    productPageView(product) {
        this.pageType = 'product';
        this.productId = product.id;
        this.totalValue = parseFloat(product.price);
    }

    basketPageView(basket) {
        this.categoryPageView(basket);
        this.pageType = 'cart';
    }

    orderPageView() {
        this.pageType = 'purchase';
        this.productId = '';
        this.totalValue = 0;
    }

    orderThankyouPageView(basket) {
        this.basketPageView(basket);
        this.pageType = 'purchase';
    }

    searchPageView() {
        this.pageType = 'searchresults';
        this.productId = '';
        this.totalValue = 0;
    }
}




// WEBPACK FOOTER //
// ./modules/tracker/google-remarketing.js